import React, { useRef, useState } from "react";
import test from "../../assets/Testimonials/WhatsApp Image 2025-01-10 at 12.06.51 PM (1).jpeg";
import test1 from "../../assets/Testimonials/WhatsApp Image 2025-01-10 at 2.36.46 PM.jpeg";
import test2 from "../../assets/Testimonials/WhatsApp Image 2025-01-10 at 12.06.51 PM.jpeg";
import test3 from "../../assets/Testimonials/WhatsApp Image 2025-01-10 at 12.06.51 PM (2).jpeg";
import test4 from "../../assets/Ellipse5.png";
import testcar1 from "../../assets/Product Image.png";
import testcar2 from "../../assets/M8_Competition_Convertible 1.png";
import testcar3 from "../../assets/png-clipart-2017-land-rover-range-rover-evoque-2018-land-rover-range-rover-jaguar-land-rover-car-land-rover-compact-car-vehicle 1.png";
import testcar4 from "../../assets/Mercedes-Benz-G-Class_1429 1.png";
import testcar5 from "../../assets/thar-exterior-right-front-three-quarter-35 1.png";

const testimonials = [
  {
    image: test,
    name: "Ramesh K",
    feedback:
      "Buying my first luxury car was an amazing experience thanks to this platform! The car was exactly as described, and the whole process was seamless. I’m thrilled with my purchase!",
    carImage: testcar1,
  },
  {
    image: test1,
    name: "Durga Prasad",
    feedback:
      "The design sprint workshop organized by our team was a great success! We collaborated effectively to generate innovative ideas and solutions. Looking forward to implementing them in our upcoming projects.",
    carImage: testcar5,
  },
  {
    image: test2,
    name: "Pranav Kumar",
    feedback:
      "The user testing session provided valuable insights into our product's usability. We identified key areas for improvement and are excited to refine the user experience further.",
    carImage: testcar3,
  },
  {
    image: test3,
    name: "Arati",
    feedback:
      "The design sprint workshop organized by our team was a great success! We collaborated effectively to generate innovative ideas and solutions. Looking forward to implementing them in our upcoming projects.",
    carImage: testcar4,
  },
  // {
  //   image: test4,
  //   name: "Sara L",
  //   feedback:
  //     "The design sprint workshop organized by our team was a great success! We collaborated effectively to generate innovative ideas and solutions. Looking forward to implementing them in our upcoming projects.",
  //   carImage: testcar2,
  // },
];

const Testimonials = () => {
  const sliderRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - sliderRef.current.offsetLeft);
    setScrollLeft(sliderRef.current.scrollLeft);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX) * 1.5;
    sliderRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <>
      <div className="text-center leading-normal gap-6 flex flex-col items-center mt-6 self-stretch sm:mb-14">
        <h4
          className="font-normal text-xl sm:text-3xl text-black leading-normal w-4/5"
          style={{ fontFamily: "Ballega" }}
        >
          Testimonials
        </h4>
        <p
          className="text-black text-base md:text-lg font-normal leading-normal w-4/5"
          style={{ fontFamily: "Barlow Condensed" }}
        >
          "See what our satisfied customers have to say about their experiences
          with us. From finding their dream cars to selling with ease, our
          clients share their stories of trust, convenience, and satisfaction.
          We take pride in delivering exceptional service and providing a
          seamless car buying and selling experience. Read their real stories
          and discover why so many people choose us for their automotive needs
          in Hyderabad."
        </p>
        <div
          ref={sliderRef}
          className="overflow-x-auto flex gap-6 cursor-grab py-7 pl-16"
          style={{
            scrollBehavior: "smooth",
            overflowX: "auto",
            width: "100%",
            userSelect: "none",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          {testimonials.map((testimonial, index) => (
            <section
              key={index}
              className="pt-6 pl-6 text-start flex-shrink-0"
              style={{
                boxShadow: `0px 4px 39.5px 0px rgba(0, 0, 0, 0.25), 
                        6.667px -6.667px 6.667px 0px rgba(165, 165, 165, 0.10) inset, 
                        -6.667px 6.667px 6.667px 0px rgba(255, 255, 255, 0.10) inset`,
                width: "535px",
                height: "230px",
                marginRight: "1rem",
              }}
            >
              <div className="flex gap-4 items-center">
                <img
                  src={testimonial.image}
                  alt={`${testimonial.name} profile`}
                  className="w-16 h-16 rounded-3xl"
                />
                <h5
                  className="text-base font-bold"
                  style={{ fontFamily: "Barlow Condensed" }}
                >
                  {testimonial.name}
                  <span>
                    <br />
                    {testimonial.role}
                  </span>
                </h5>
              </div>
              <div className="flex">
                <p
                  className="text-base font-normal text-start mt-4"
                  style={{ fontFamily: "Barlow Condensed" }}
                >
                  {testimonial.feedback}
                </p>
                <img
                  src={testimonial.carImage}
                  alt="car"
                  className="w-64 h-28 mt-6"
                />
              </div>
            </section>
          ))}
        </div>
      </div>
    </>
  );
};

export default Testimonials;
